module.exports = __webpack_public_path__ + "static/demo-06593f0dc79de1b95091c5527a65ec89.png";